import { parseStatic, parseStatics } from '@core/utils/assets.utils'
import { Team } from '@core/models/team.models'
import { TeamComparisonHolder } from '@pages/team/models/team.models'
import { StaticOrientation } from '@core/enums/statics.enum'

export const buildTeamComparisonHolder = (comparison: { teamA: Team; teamB: Team }): TeamComparisonHolder => ({
  nameTeamA: comparison?.teamA?.shortName || comparison?.teamA?.name,
  nameTeamB: comparison?.teamB?.shortName || comparison?.teamB?.name,
  abbreviationTeamA: comparison?.teamA?.abbreviation,
  abbreviationTeamB: comparison?.teamB?.abbreviation,
  logoTeamA: parseStatic(comparison?.teamA?.statics || [], StaticOrientation.Portrait),
  logoTeamB: parseStatic(comparison?.teamB?.statics || [], StaticOrientation.Portrait),
  teamA: comparison?.teamA,
  teamB: comparison?.teamB
})

export const parseTeamStatics = (team: Team) => ({
  ...team,
  ...parseStatics(team.statics, [StaticOrientation.Portrait])
})
